import { Inline } from '@99designs/emu';
import { Scroll } from '@99designs/marketing-ui';
import { linkTo } from '@99designs/routing';
import { DesignCard } from '../components/DesignCard';
import type { Design } from '../types';

export interface DesignInspirationProps {
    designs: Design[];
}

export function DesignInspiration({ designs }: DesignInspirationProps) {
    return (
        <Scroll controlsEnabled={true}>
            <Inline space="1.5bu">
                {designs.map((design, index) => (
                    <DesignCard
                        key={index}
                        src={design.image}
                        displayName={design.designer.displayName}
                        profileUrl={linkTo.userProfile(design.designer.id)}
                        avatarUrl={linkTo.userAvatar(design.designer.id)}
                    />
                ))}
            </Inline>
        </Scroll>
    );
}
